import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newInterchange() {
    let interchangeDetails = {
      truck_id: $(".truck_id").val(),
      requisition_id: $(".requisition_id").val(),
      cargo_id: $(".cargo_id").val(),
      interchange_no: $(".interchange_no").val(),
      interchange_file: $(".interchange_file").val()
    };
    console.log(interchangeDetails);
    
    $(".creatingInterchange").hide(), $(".creatingInterchangeLoader").show();
    baseurl.post(rt.newInterchange, interchangeDetails).then(res => {
      $(".creatingInterchange").show();
      $(".creatingInterchangeLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.interchangeCreateSuccess();
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //interchange exits
        ers.InterchangeExists();
      } else if (res.data.code === 404) {
        //error on creating
        ers.errorCreatingInterchange();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/actions.js